export const isEmail = ( email ) => {
    // eslint-disable-next-line no-useless-escape
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if ( re.test(email) ) {
        // this is a valid email address
        // call setState({email: email}) to update the email
        // or update the data in redux store.
        return true;
    }
    else {
        // invalid email, maybe show an error to the user.
        return false;
    }
}

const CARACTER_MASCARA = '•';
const LOCAL_CHARS_VISIBLES = 2;
const DOMINIO_CHARS_VISIBLES = 1;

const enmascararParte = ( texto, charsVisibles ) => {
    const visibles = texto.slice( 0, charsVisibles );
    const ocultos = CARACTER_MASCARA.repeat( Math.max( texto.length - charsVisibles, 0 ) );
    return visibles + ocultos;
}

export const enmascararEmail = ( email ) => {
    if ( !email || !email.includes( '@' ) ) {
        return email || '';
    }
    if ( email.includes( CARACTER_MASCARA ) ) {
        return email;
    }

    const [ localPart, dominioCompleto ] = email.split( '@' );
    const localEnmascarado = enmascararParte( localPart, LOCAL_CHARS_VISIBLES );

    const ultimoPunto = dominioCompleto.lastIndexOf( '.' );
    if ( ultimoPunto === -1 ) {
        return `${ localEnmascarado }@${ enmascararParte( dominioCompleto, DOMINIO_CHARS_VISIBLES ) }`;
    }

    const nombreDominio = dominioCompleto.slice( 0, ultimoPunto );
    const tld = dominioCompleto.slice( ultimoPunto );
    const dominioEnmascarado = enmascararParte( nombreDominio, DOMINIO_CHARS_VISIBLES ) + tld;

    return `${ localEnmascarado }@${ dominioEnmascarado }`;
}

export const isDateBars = ( date ) => {
    // eslint-disable-next-line no-useless-escape
    let re = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
    if ( re.test(date) ) {
        return true;
    }
    else {
        return false;
    }
}